
import React, { Component } from 'react';
import {SideBar, SideBarHead, SideList, SideListItemGeneric} from 'app/components/SideBar/';
import DynamicDemoForm from './DynamicDemoForm';
import NewDynamicDemo from './models/DynamicDemoModel';
import DynamicDemoHome from './components/DynamicDemoHome/DynamicDemoHomeComponent';
import DynamicDemoService from "../../../services/dynamicDemo.service";
import  GetErrorMessage  from 'app/helpers/error-message'
import {ShowError, ShowSuccess} from "app/components/toast"
import { Loading } from '@ecosystem/ui-lib/core/components/Loading';
import {BlockUi} from 'app/components/Basics/';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import Modal from 'app/components/Modal';
import './DynamicDemoComponent.scss';

class DynamicDemo extends Component {	
	constructor (props) {
	super(props);
		this.state = {
			search: '',			
			allData: [],
			filteredData: [],			
			loading: false,
			errorMessage: null,
			selectedDynamicDemo: null,
			originalSelectedDynamicDemo: null,
			uiBlocked: false,
			editorOpen: false,			
			metadata: {
				questions: [],
				channels: []
			}
		}
	}

	setSearchState(event) {    
		var value = event.target.value;    
		this.setState({search: value});
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.state.search !== prevState.search) {     
			this.filterDynamicDemos(this.state.search);
		}

		if (this.state.editorOpen !== prevState.editorOpen) {
			if (this.state.editorOpen) {
			//retrigger selected question if editor was closed        
			this.setState({selectedDynamicDemo: this.state.selectedDynamicDemo});
			}
		}    
	}

	filterDynamicDemos(term) {		
		if (term !== '') {
			const filteredData = this.state.allData
			.filter(i => (i.demoQuestionCode  && i.demoQuestionCode.toLowerCase().includes(term.toLowerCase())));
			let newFilteredData = [...filteredData];
			this.setState({ filteredData: newFilteredData});      
		}
		else {
			let newFilteredData = [...this.state.allData];
			this.setState({ filteredData: newFilteredData});     
		}
	}

	queryMetadata() {		
		this.toggleUiBlock(true);
		DynamicDemoService.getMetadata()
				.then(response =>{					
					this.setState({
						metadata: response.data					
					});
					this.toggleUiBlock(false);
					return response;          
				})
				.catch(error => {			  
					this.toggleUiBlock(false);
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.setState({ loading: false, errorMessage: errorMessage});            
			})
	}

	componentDidMount() {
		this.queryMetadata();
		this.queryDynamicDemos('');		
	}

	openEditor() {
		this.setState({ editorOpen: true });
	}

	closeEditorButtonOnClick() {
		if (this.shouldLosePossibleChangesOnEditor(this.closeEditor)) {
			this.closeEditor();
		}
	}

	closeEditor() {
		this.setState({ editorOpen: false });
		this.setSelectedItem(null);
	}

	queryDynamicDemos(term) {
		this.setState({ loading: true, filteredData: [] });
		DynamicDemoService.find(term)
			.then(response =>{				
				this.setState({ filteredData: response.data,
					allData:  response.data,					
					loading: false				
				}, function() { this.filterDynamicDemos(this.state.search); });
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ loading: false, errorMessage: errorMessage});            
			})
	}

	getDynamicDemoById(id) {		
		this.toggleUiBlock(true)
		DynamicDemoService.getDynamicDemoById(id)
			.then(response => {				
				this.updateSelectedDynamicDemo(response.data);		
				this.updateSavedDynamicDemoOnList(response.data);					
				this.setState(
					{originalSelectedDynamicDemo: cloneDeep(response.data)}
				);
				this.toggleUiBlock(false)
				return response;          
			})
			.catch(error => {			  
				let errorMessage = GetErrorMessage(error);
				console.log("errorMessage on catch");
				console.log(errorMessage);
				this.setState({ errorMessage: errorMessage});    
				this.toggleUiBlock(false)        
			})
	}	

	getSelectedItem(dynamicDemoid) {		
		this.setState({clickedDynamicDemoid: dynamicDemoid});		
		this.openEditor();
		if (this.shouldLosePossibleChangesOnEditor(()=>this.getDynamicDemoById(dynamicDemoid))) {			
			this.getDynamicDemoById(dynamicDemoid)			
		}	
	}

	setSelectedItem(selectedDynamicDemo) {		
		this.updateSelectedDynamicDemo(selectedDynamicDemo);
	}	

	shouldLosePossibleChangesOnEditor(callbackAfterLoseChangesConfirmation) {		
		if (this.didSelectedDynamicDemoChange()) {
			this.showLoseChangeConfirmationModal(callbackAfterLoseChangesConfirmation);
			return false;	
		}
		else {	
			return true;
		}	
	}

	didSelectedDynamicDemoChange() {
		let selectedDynamicDemo = this.state.selectedDynamicDemo;
		if (!selectedDynamicDemo) return false;
		let questionsAreEquals = isEqual(selectedDynamicDemo, this.state.originalSelectedDynamicDemo);
		return !questionsAreEquals;
	  }

	showLoseChangeConfirmationModal(callbackAfterLoseChangesConfirmation) {
		this.setState({ 
			loseChangesModalText: `There are unsaved changes to the dynamic demographic '${this.state.selectedDynamicDemo.demoQuestionCode}'. Are you sure do you want to leave without saving?`,
			callbackAfterLoseChangesConfirmation: callbackAfterLoseChangesConfirmation
		});
	}

	confirmLoseChangesModalHandler() {
		let filteredData = this.rollbackToOriginalDynamicDemo(this.state.filteredData, this.state.originalSelectedDynamicDemo);
		let allData = this.rollbackToOriginalDynamicDemo(this.state.allData, this.state.originalSelectedDynamicDemo);	

		this.setState({allData: allData, filteredData: filteredData
		}, this.state.callbackAfterLoseChangesConfirmation);
		this.setState({clickedDynamicDemoid: null});
		this.hideLoseChangesModal();
	}

	rollbackToOriginalDynamicDemo(list, originalSelectedItem) {
		const index = list.findIndex(item => item.id === this.state.selectedDynamicDemo.id);	
		list[index] = originalSelectedItem;
		return list;
	}

	hideLoseChangesModal() {
		this.setState({loseChangesModalText: ''})
	}

	isItemSelected(dynamicDemoId) {    
		if (this.state && this.state.selectedDynamicDemo && 
			this.state.selectedDynamicDemo.id === dynamicDemoId) {
			return true;
		} else {
			return false;
		}
	}

	toggleUiBlock(blockUi) {
		this.setState ({uiBlocked: blockUi});
	} 

	addNewDynamicDemoHandler = event => {
		if (this.shouldLosePossibleChangesOnEditor(() => this.addNewDynamicDemo())) {
			this.addNewDynamicDemo()
		}    
		event.preventDefault();
	}

	addNewDynamicDemo() {		
		const newDynamicDemo = NewDynamicDemo();		
		this.setSelectedItem(null);
		this.setSelectedItem(newDynamicDemo);
		this.openEditor();
	}

	removeDeletedDynamicDemo(dynamicDemoId) {    
		const newFilteredData = this.state.filteredData.filter(i => i.id !== dynamicDemoId);
		const newAllData = this.state.allData.filter(i => i.id !== dynamicDemoId);
		this.setState({ filteredData: newFilteredData,
			allData: newAllData
			});    
	}

	updateSavedDynamicDemoOnList(selectedDynamicDemo) {
		let newFilteredData = [...this.updateDynamicDemoList(this.state.filteredData, selectedDynamicDemo)];	
		let newAllData = [...this.updateDynamicDemoList(this.state.allData, selectedDynamicDemo)];
		this.setState({filteredData: []});
		this.setState({filteredData: newFilteredData, 
			allData: newAllData
		});
	}

	updateDynamicDemoList(list, selectedDynamicDemo) {		
		var index = list.findIndex(q => q.id === selectedDynamicDemo.id);
		if (index === -1) {
			list.push(selectedDynamicDemo);      
		}
		else {
			list[index] = selectedDynamicDemo;      
		}
		return list;
	}

	getListItems() {
		return this.state.filteredData.map(dynamicDemo => 
			<div key={dynamicDemo.id}>
				<SideListItemGeneric key={dynamicDemo.id}
					id={dynamicDemo.id}					
					getSelectedItem={this.getSelectedItem.bind(this)}				
					isItemSelected={this.isItemSelected(dynamicDemo.id)}
					menuItemId={dynamicDemo.id}
				>
					{dynamicDemo.dynamicDemoQuestion.demoQuestionCode}
				</SideListItemGeneric>
		</div>
		)
	}	

	updateSelectedDynamicDemo(selectedDynamicDemo) {		
		this.setState({selectedDynamicDemo: selectedDynamicDemo})
	}
	

    render() {
        return (
			<BlockUi tag="div" blocking={this.state.uiBlocked}>  
			<main className="app-body dynamicdemos">                   
				<SideBar>
					<SideBarHead canChangeData={this.props.userPermissions?.CanChangeDynamicDemo} tagName="SideBarHead" headline="Dynamic Demos" fontSize="h2" addButton addButtonLabel="Demo" addButtonCallBack={this.addNewDynamicDemoHandler.bind(this)}
						toolbar={(
						<div>
							{/* <IntroTextIcon className="icon orange clickable" title="Intro Texts"/>
							<SettingsIcon className="icon orange clickable" title="Settings"/> */}
						</div>  
					)} onChange={this.setSearchState.bind(this)}
					/>                  
					<SideList tagName="SideList">                  
						<Loading active={this.state.loading}></Loading>
						<div>
							{this.getListItems()}
						</div>
					</SideList>					
				</SideBar>

				<div className="app-content scrollbox">
					{this.state.editorOpen && ( <DynamicDemoForm openEditor={this.openEditor.bind(this)} 
							didSelectedDynamicDemoChange={this.didSelectedDynamicDemoChange.bind(this)}
							closeEditorButtonOnClick={this.closeEditorButtonOnClick.bind(this)} 
							closeEditor={this.closeEditor.bind(this)}
							removeDeletedDynamicDemo={this.removeDeletedDynamicDemo.bind(this)} 
							toggleUiBlock={this.toggleUiBlock.bind(this)} 
							selectedDynamicDemo={this.state.selectedDynamicDemo}
							updateSelectedDynamicDemo={this.updateSelectedDynamicDemo.bind(this)}
							updateSavedDynamicDemoOnList={this.updateSavedDynamicDemoOnList.bind(this)}							
							getDynamicDemoById={this.getDynamicDemoById.bind(this)}							
							canChangeData={this.props.userPermissions?.CanChangeDynamicDemo}
							metadata={this.state.metadata}
							/> )}
					{!this.state.editorOpen && ( <DynamicDemoHome />)}
				</div>
				{this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
				{this.state.loseChangesModalText && ( <Modal size="small" content={this.state.loseChangesModalText} confirmModalHandler={this.confirmLoseChangesModalHandler.bind(this)} cancelModalHandler={this.hideLoseChangesModal.bind(this)} />)}
			</main>
			</BlockUi>
        );
    }
}

export default DynamicDemo;